export default {
  toasts: {
    printing: 'Se imprimă...',
    print_failed: 'Imprimarea a eșuat. Vă rugăm să încercați din nou',
    orders: {
      print_one: 'Se imprimă {{count}} bon: Comanda <strong>#{{orderNumber}}</strong>...',
      print_few: 'Se printează {{count}} bonuri: Comanda <strong>#{{orderNumber}}</strong>...',
      print_other: 'Se imprimă {{count}} bonuri: Comanda <strong>#{{orderNumber}}</strong>...',
    },
  },
};
